import {PayPerUseMetricsResponse} from '@dms/api/settings';

import {isHiddenOperation} from './isHiddenOperation';

/**
 * `metrics.totalCount` with the hidden operations' counts subtracted out, so
 * the headline total and the cards' "% of total" reflect only visible
 * operations. The backend includes hidden pairs in `operationTypes`, so the FE
 * has the counts it needs to remove.
 */
export const getVisibleTotalCount = (metrics: PayPerUseMetricsResponse): number =>
  metrics.operationTypes
    .filter(isHiddenOperation)
    .reduce((total, operation) => total - operation.count, metrics.totalCount);
